import { safetyHandler } from './utils';

export const EmailAcquisitionChannel = new Proxy(
  {
    BOOKING: 'BOOKING',
    CHARITY_OPT_IN: 'CHARITY_OPT_IN',
    EVENT_PAGE_EMAIL_RECOMMENDATIONS: 'EVENT_PAGE_EMAIL_RECOMMENDATIONS',
    FACEBOOK_LANDING_PAGE: 'FACEBOOK_LANDING_PAGE',
    LOGIN: 'LOGIN',
    MANUAL_CHALLENGEAWARDS: 'MANUAL_CHALLENGEAWARDS',
    TRAINING_PLAN: 'TRAINING_PLAN',
    UNKNOWN: 'UNKNOWN',
    VIRTUAL_EVENT_SUBMISSION: 'VIRTUAL_EVENT_SUBMISSION',
    ORGANISER: 'ORGANISER',
  },
  safetyHandler('EmailAcquisitionChannel'),
);
